module.exports = __webpack_public_path__ + "media/react/gmat/organisms/official_practice_tests_card/practice_exams_5_6-f7ae0784e6760b986ab749d6b71eb3fd.png";